module.exports = __webpack_public_path__ + "BannerSecundario_OpticalFiber.jpg?98bfa11c0d4a6cc038c708a8a5df5919";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/products/BannerSecundario_OpticalFiber.jpg
// module id = 206
// module chunks = 0